import { args } from '../../../common/args';
export const onNewNotification = {
  onNewNotification: {
    args: {
      notifications: args.arrayOf(args.anyObject())
    }
  }
};